// extracted by mini-css-extract-plugin
export default {"courseProgress":"course-progress_courseProgress__ap3w-","printOnlyGlossary":"course-progress_printOnlyGlossary__ZxrNr","loadingScreen":"course-progress_loadingScreen__EID9z"};